<template>
  <div
    v-if="item"
    :class="{
      'flex-end mobile-none tablet-none': mode === 'DESKTOP',
      'flex-between width-percent-100 margin-bottom-16 desktop-none':
        mode === 'MOBILE',
    }"
  >
    <div class="flex-start gap-8">
      <span
        v-if="item.incomplete_completion_user"
        class="chips chips--error-light"
      >
        {{ $lang.suspension }}
      </span>
      <StatusBox
        v-if="checkPermission(permissions, ['admin'])"
        class="margin-left-8"
        :item="item"
        @handleReloadList="handleReloadList"
      />
    </div>
    <span class="flex-end">
      <router-link
        v-if="isCaseShow"
        :to="casesLink"
        class="color-complementary-200 icon-hover"
        v-b-tooltip.hover
        :title="$lang.showCenterExecuteCases"
      >
        <mdicon name="folder-eye-outline" size="24" />
      </router-link>
      <MenuPopupWrapper
        iconClass="color-complementary-200 icon-hover"
        menuClass="left-0 top-10 z-index-1 padding-top-24"
        :items="menuPopupItems"
        :permissions="permissions"
        :showMenu="isMenuPopup"
        :rowItem="item"
        :hasEventCapturing="false"
        @click="handleOpenMenuPopup"
        @close="handleCloseMenuPopup"
      />
    </span>
  </div>
</template>

<script>
import { MenuPopupWrapper } from "@/components/re-design";
import StatusBox from "./StatusBox.vue";
import { computed, inject, ref, toRefs } from "vue";
import { pathOr, includes } from "ramda";
import { checkPermission } from "@/shared/utils";

export default {
  components: { MenuPopupWrapper, StatusBox },
  props: {
    mode: {
      type: String,
      default: "DESKTOP",
    },
    item: {
      type: Object,
      default: null,
    },
    menuPopupItems: {
      type: Array,
      default: () => [],
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    casesLink: {
      type: String,
      default: "",
    },
  },
  setup(props, { emit }) {
    // bind props
    const { item } = toRefs(props);

    // injects data
    const checkSharedAccesses = inject("checkSharedAccesses");

    const handleReloadList = () => emit("handleReloadList");

    // handle menu popup
    const isMenuPopup = ref(false);
    const handleOpenMenuPopup = () => (isMenuPopup.value = !isMenuPopup.value);
    const handleCloseMenuPopup = () => (isMenuPopup.value = false);

    const isCaseShow = computed(() => {
      const allowStatus = [2, 3, 4, 5];
      const allowUserExecutiveRoles = [2, 3, 4, 5, null];

      const statusId = pathOr(null, ["status"], item.value);
      const userExecutiveRoleId = pathOr(
        null,
        ["executive_role_id"],
        item.value
      );

      return (
        includes(statusId, allowStatus) &&
        includes(userExecutiveRoleId, allowUserExecutiveRoles) &&
        checkSharedAccesses("CASE-SHOW")
      );
    });

    // return data to be used in template
    return {
      item,
      handleReloadList,
      isMenuPopup,
      handleOpenMenuPopup,
      handleCloseMenuPopup,
      checkPermission,
      isCaseShow,
    };
  },
};
</script>
